<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Industrialização da produção</h2>
          <p>
            A compra da unidade de Andradina (SP) possibilita a entrada da
            Companhia na área de <strong>produtos industrializados</strong> e no
            mercado americano. É também um importante passo por ter sido a
            primeira fábrica da empresa em São Paulo.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
          <img
            src="../assets/img/1999/1999-1.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2001/11/11/g/20011111-39471-spo-39-cid-c3-not-axeaphx.jpg'
              )
            "
            class=""
          />
          <img
            src="../assets/img/1999/1999-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1995/10/24/g/19951024-37260-nac-0110-neg-sn2-not-sqaaqkg.jpg'
              )
            "
            class=""
          />
          <img
            src="../assets/img/1999/1999-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1991/05/02/g/19910502-35649-nac-0054-eco-10-not-ahsxhks.jpg'
              )
            "
            class=""
          />
          <img
            src="../assets/img/1999/1999-4.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1996/02/20/g/19960220-37379-spo-0066-sbo-z4-not-kkkxpep.jpg'
              )
            "
            class="negativo"
          />
          <img
            src="../assets/img/1999/1999-5.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2001/08/03/g/20010803-39371-spo-21-eco-b9-not-aagapex.jpg'
              )
            "
            class=""
          />
        </div>
        <div class="formato__warpper__item--black">
          <h2>
            É <strong><i>self-service</i></strong> ou
            <strong>por quilo</strong>?
          </h2>
          <p>
            Outro movimento que ganhou força nos anos 1990 em busca de comida
            mais saudável foi o aparecimento de restaurantes
            <strong><i>self-service</i></strong> e <strong>por quilo</strong>.
          </p>
          <blockquote>
            É um modelo que surge na esteira do fast-food, atendendo a demanda
            da rapidez, mas entregando uma dieta mais vinculada à nossa cultura
            alimentar. A pessoa consegue pegar um alimento pronto, pagando só
            pelo que consome, em 20 minutos”,
            <p>diz o professor Fábio Bitelli,</p>
          </blockquote>
          <p>
            do Senac, destacando a presença desses estabelecimentos nas grandes
            cidades. Na indústria, vale citar ainda a criação do programa
            Brazilian Beef, que contribuiu com o aumento das exportações de
            carne bovina do País.
          </p>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 372px 1fr 1fr;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      margin-top: 140px;
      @include media("<=desktop") {
        margin-top: 40px;
        padding: 20px;
      }
      &--image {
        display: grid;
        position: relative;
        grid-template-columns: 1fr 1fr;
        max-height: 705px;
        padding-top: 26px;
        margin-left: -110px;
        @include media("<=desktop") {
          margin: 0;
          padding: 0 20px 20px;
          margin-top: -30px;
        }
        img {
          cursor: pointer;
          transition: 0.3s ease-in-out;
          &:hover {
            transform: scale(1.1);
          }
        }

        .span2 {
          grid-column: span 2;
          margin-top: 20px;
        }
        .fistItem {
          grid-column: 2;
          margin-left: -100px;
        }
        .secondItem {
          margin-top: -50px;
        }
        .terceiroItem {
          margin-top: 30px;
          margin-left: 20px;
        }
        .negativo {
          margin-top: -130px;
        }
        span {
          width: 65px;
          color: color(cBLue6);
          margin-left: auto;
          margin-top: auto;
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBLue6);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
        max-width: 220px;
        @include media("<=desktop") {
          max-width: 100%;
        }
      }

      &--black {
        margin-left: 2rem;
        padding-block: 50px;
        @include media("<=desktop") {
          margin: 0;
          padding: 40px 20px;
          background: color(cBlue5);
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          p {
            display: inline-block;
          }
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: color(cBlue5);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
